export const tshirtSizes = [
	'Adult XS',
	'Adult S',
	'Adult M',
	'Adult L',
	'Adult XL',
];
